import { Dialog, DialogContent } from "@mui/material";
import { createContext, useMemo, useState, Fragment } from "react";

const DialogContext = createContext();

const DialogProvider = ({ children }) => {
  /**
   * Each dialog: { id: string, component: ReactNode, props: object }
   */
  const [dialogs, setDialogs] = useState([]);

  const openDialog = ({ component, props }) => {
    const id = crypto.randomUUID(); // genera un id único
    setDialogs((prev) => [...prev, { id, component, props }]);
    return id; // puedes devolver el id si quieres cerrar luego de forma externa
  };

  const closeDialog = (id) => {
    setDialogs((prev) => prev.filter(dialog => dialog.id !== id));
  };

  const closeAllDialogs = () => {
    setDialogs([]);
  };

  return (
    <DialogContext.Provider value={{ openDialog, closeDialog, closeAllDialogs }}>
      {children}
      {dialogs.map(({ id, component: Component, props }) => (
        <Dialog
          key={id}
          open
          onClose={() => closeDialog(id)}
         
          BackdropProps={{
            style: { backdropFilter: "blur(5px)", background: "#00000020" }
          }}
          PaperProps={{
            sx: {
              borderRadius: "var(--radius)",
              maxWidth: "90vw",
              maxHeight : "100vh"
            },
          }}
        >
          <DialogContent  sx={{
            padding : "calc(var(--padding) + .1rem)",
            // background : "red"
          }}>
          <Component {...(props ?? {})} id={id} onClose={() => closeDialog(id)} />
          </DialogContent>
        </Dialog>
      ))}
    </DialogContext.Provider>
  );
};

export { DialogContext, DialogProvider };
